import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core';
import React from 'react';

export type OptionValue = boolean | undefined;

export type Option = {
  label: string;
  value: OptionValue;
};

export interface SingeSelectionProps {
  title?: string;
  options: Option[];
  defaultValue?: OptionValue;
  onChange?: (option: OptionValue) => void;
}

const SingleSelection: React.FC<SingeSelectionProps> = ({
  title,
  options,
  defaultValue,
  onChange
}) => {
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    if (!onChange) return;

    let retValue;

    if (value === 'true') {
      retValue = true;
    } else if (value === 'false') {
      retValue = false;
    }

    onChange(retValue);
  };

  return (
    <React.Fragment>
      {title && <Typography variant="h4">{title}</Typography>}

      <Box mt={1}>
        <RadioGroup
          row
          defaultValue={
            defaultValue === undefined ? '' : defaultValue.toString()
          }
          onChange={handleChange}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.label}
              value={option.value === undefined ? '' : option.value.toString()}
              control={<Radio />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      </Box>
    </React.Fragment>
  );
};

export default SingleSelection;
